export default __webpack_public_path__ + "static/media/01.db4b5a0e.jpg";